<template>
  <div>
    <div v-if="description" class="paragraph-s paragraph-dark-gray">{{ description }}</div>
    <location-with-icon v-if="location" :location="location" />
  </div>
</template>

<script>

import LocationWithIcon from './LocationWithIcon';

export default {
  props: {
    title: String,
    description: String,
    location: {type: String, default: ''},
    clickable: {type: Boolean, default: false}
  },
  components: {
    LocationWithIcon
  }
};
</script>
